var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistorico(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10.0001C0 4.47717 4.47718 3.05176e-05 9.99995 3.05176e-05C15.5187 0.00980049 19.9902 4.48124 20 10.0001C20 15.5229 15.5228 20 9.99995 20C4.47718 20 0 15.5229 0 10.0001ZM1.99999 10.0001C1.99999 14.4183 5.58169 18 9.99995 18C14.4152 17.9927 17.9926 14.4153 18 10.0001C18 5.58174 14.4182 2.00003 9.99995 2.00003C5.58169 2.00003 1.99999 5.58174 1.99999 10.0001Z",
    fill: "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0044 4.1978H9.00443V10.42L13.1933 14.5867L14.6044 13.1689L11.0044 9.58891V4.1978Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistorico);
export default __webpack_public_path__ + "static/media/historico.90c0ac15f42a0e2e45666882fe39016b.svg";
export { ForwardRef as ReactComponent };